import { IFilterListOption } from '@app/lib/interfaces';
import { IResearchStudyStatusIcons } from './types';
import { resourceStatuses } from '@app/lib/constants/fhir.constant';

export const DEFAULT_GROUP_POST_REQUEST = {
  resourceType: 'Group'
};

export const MANAGE_STUDIES_ICONS: IResearchStudyStatusIcons = {
  active: 'check',
  draft: 'description',
  retired: 'close',
};

export const PRIMARY = 'primary';

export const RECRUITMENT_CONTACT = 'recruitment-contact';

export const RESEARCH_STUDY_OBJECTIVE_TYPE = 'http://terminology.hl7.org/CodeSystem/research-study-objective-type';

export const RESEARCH_STUDY_PARTY_TYPE = 'http://hl7.org/fhir/CodeSystem/research-study-party-type';

export const RESEARCH_STUDY_PHASE_SYSTEM = 'http://terminology.hl7.org/CodeSystem/research-study-phase';

export const RESEARCH_STUDY_PHASE_ONE = 'phase-1';

export const RESEARCH_STUDY_PHASES = ['n-a', 'early-phase-1', RESEARCH_STUDY_PHASE_ONE, 'phase-2', 'phase-3', 'phase-4'];

export const RESEARCH_STUDY_STATUSES = Object.values(resourceStatuses);

export const RESEARCH_STUDY_THERAPEUTIC_AREAS_SYSTEM = 'http://labcorp.com/fhir/ctra/CodeSystem/covance-therapeutic-area-CodeSystem-CodeSystem';

export const RESEARCH_STUDY_URL_CODES = ['recruitment-page', 'contact-page', 'registry-page'];

export const RESEARCH_STUDY_URL_TYPE = 'http://hl7.org/fhir/ValueSet/research-study-url-type';

export const STUDIES_STATE_KEY = 'studies';

export const MANAGE_STUDIES_FILTER_OPTIONS: IFilterListOption[] = [
  {
    displayName: 'Status',
    paramName: 'status',
    values: RESEARCH_STUDY_STATUSES,
  }
];
